var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoiceIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 13.956C14.8669 13.956 14.7419 13.9143 14.6252 13.831C14.3502 13.6226 14.2919 13.231 14.5002 12.956C15.8086 11.2143 15.8086 8.78096 14.5002 7.03929C14.2919 6.76429 14.3502 6.37262 14.6252 6.16429C14.9002 5.95596 15.2919 6.01429 15.5002 6.28929C17.1336 8.47262 17.1336 11.5226 15.5002 13.706C15.3752 13.8726 15.1919 13.956 15.0002 13.956Z",
    fill: "#333448",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5237 16.0445C16.3903 16.0445 16.2653 16.0028 16.1487 15.9195C15.8737 15.7112 15.8153 15.3195 16.0237 15.0445C18.2487 12.0778 18.2487 7.92783 16.0237 4.96116C15.8153 4.68616 15.8737 4.2945 16.1487 4.08616C16.4237 3.87783 16.8153 3.93616 17.0237 4.21116C19.582 7.6195 19.582 12.3862 17.0237 15.7945C16.907 15.9612 16.7153 16.0445 16.5237 16.0445Z",
    fill: "#333448",
    fillOpacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.1252 6.17054V13.8205C13.1252 15.2539 12.6085 16.3289 11.6835 16.8455C11.3085 17.0539 10.8918 17.1539 10.4585 17.1539C9.79183 17.1539 9.07516 16.9289 8.34183 16.4705L5.9085 14.9455C5.74183 14.8455 5.55016 14.7872 5.3585 14.7872H4.5835V5.20387H5.3585C5.55016 5.20387 5.74183 5.14554 5.9085 5.04554L8.34183 3.52054C9.5585 2.7622 10.7502 2.62887 11.6835 3.14554C12.6085 3.6622 13.1252 4.7372 13.1252 6.17054Z",
    fill: "#333448",
    fillOpacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58317 5.21094V14.7943H4.1665C2.14984 14.7943 1.0415 13.6859 1.0415 11.6693V8.33594C1.0415 6.31927 2.14984 5.21094 4.1665 5.21094H4.58317Z",
    fill: "#333448",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceIcon02);
export default __webpack_public_path__ + "static/media/voice-icon-02.14f2881a34ef44afc874ea6e2f257dd3.svg";
export { ForwardRef as ReactComponent };